// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatarContainer--3R0DJdLv:hover .avatarEditContainer--8wy7Pz7U {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.avatarEditContainer--8wy7Pz7U {\n  display: none;\n}\n\n.avatarEditContainer--8wy7Pz7U:hover {\n  cursor: pointer;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatarContainer": "avatarContainer--3R0DJdLv",
	"avatarEditContainer": "avatarEditContainer--8wy7Pz7U"
};
export default ___CSS_LOADER_EXPORT___;
